import { AuxiliumComponent } from "../auxilium-component";

export default class Tab extends AuxiliumComponent {
	static observable = ["label", "casing", "icon", "close-tooltip"];
	static observableBooleans = ["selected", "allow-close", "selected"];

	constructor() {
		super();

		this._allowClose = this.allowClose;
		this.closeTooltip ??= "Close tab";
		this.preventButtons = this.closest("chip-tabgroup")?.preventButtons;

		if (this.selected) { this.Select(); }
	}

	parsedCallback() {
		const button = document.createElementWithContents(this.preventButtons ? "span" : "button", document.createElementWithContents("span", this.label), {
			className: `btn--base btn--tab${this.selected ? " active" : ""}`
		});

		if (!this.preventButtons) {
			Object.assign(button, {
				onclick: () => this.selected = true,
				type: "button"
			});
		}

		if (this.closest("chip-tabgroup[variation='steps']")) {
			const contents = !this.icon
				? [...this.parentElement.children].indexOf(this) + 1
				: document.createElementWithContents("chip-icon", null, { icon: this.icon });

			button.prepend(document.createElementWithContents("div", contents, {
				className: "steps__icon"
			}));

			button.appendChild(document.createElementWithContents("div", button.childNodes, { className: "step-button__wrapper" }));
		} else if (this.icon) {
			button.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon }));
		}

		this.appendChild(button);

		if (this.allowClose) {
			this.#AddCloseButton();
			this.closest("chip-tabgroup").isDynamic = true;
		}
	}

	GetContent() {
		return this.closest("chip-tabgroup")?.querySelector(`:scope > .tab-group__content > .tab-group__tab:nth-child(${this.index + 1})`);
	}

	#AddCloseButton() {
		if (this.matches(":first-child:last-child")) {
			this.allowClose = false;
		} else if (!this.querySelector(".tab__close-button"))
			this.appendChild(document.createElementWithContents("chip-button", null, {
				buttonStyle: "icon",
				icon: "fal fa-times",
				size: "sm",
				variation: "danger-tertiary",
				tooltip: this.closeTooltip,
				className: "tab__close-button",
				onclick: () => this.Destroy()
			}));
	}

	get index() {
		return [...this.parentElement.children].indexOf(this);
	}

	Destroy() {
		const group = this.closest("chip-tabgroup"),
			index = this.index;

		group.querySelector(`:scope > .tab-group__content > .tab-group__tab:nth-child(${index + 1})`)?.remove();
		this.remove();

		if (this.selected) {
			const newSelection = group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})`)
				?? group.querySelector(":scope > .tab-group__tabs > .tab__wrapper > chip-tab:last-child");

			newSelection.selected = true;
		}

		const selected = group.querySelector("chip-tab[selected]");

		if (selected?.matches(":first-child:last-child")) {
			selected.allowClose = false;
		}

		group.raiseEvent("tabclosed");
	}

	checkValidity() {
		return ![...this.closest("chip-tabgroup").querySelectorAll(`:scope > .tab-group__content > .tab-group__tab:nth-child(${this.index + 1}) chip-form`)].filter(form => !form.reportValidity()).length;
	}

	Select() {
		const group = this.closest("chip-tabgroup"),
			hadSelection = !!group.querySelector("chip-tab[selected]");

		group?.querySelectorAll(":scope > .tab-group__tabs > .tab__wrapper > chip-tab")
			.forEach(tab => {
				if (tab !== this) {
					tab.removeAttribute("selected");
				}

				const button = tab.querySelector(".btn--base");

				if (button) {
					button.toggleClass("active", tab === this);
				}
			});

		group?.querySelectorAll(":scope > .tab-group__content > .tab-group__tab")
			.forEach((tab, currentIndex) => {
				tab.toggleClass("selected", currentIndex === this.index);

				if (currentIndex === this.index) {
					const target = tab.querySelector("input:not([readonly]), chip-dropdown, textarea:not([readonly]), select, .chipside-table:not(.no-js) tbody tr:not(.table-body-label)");

					if (target?.nodeName === "TR" && !target.classList.contains("active")) {
						target.closest("table")?.Table.SelectRow(target, true);
					} else {
						target?.focus();
					}
				} else if (currentIndex < this.index) {
					const forms = [...tab.querySelectorAll("chip-form")];

					if (forms.length && !group.skipValidation) {
						group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${currentIndex + 1}) > .btn--base`)?.toggleClass("step__invalid", forms.filter(form => !form.reportValidity()).length > 0);
					}
				}
			});

		group.selectedIndex = this.index;

		if (hadSelection) {
			group.raiseEvent?.("change");
		}
	}

	SetIsValid(isValid) {
		if (this.closest("[variation='steps']")) {
			this.firstElementChild?.toggleClass("step__invalid", !isValid);
		}
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "selected":
				if (this.IsAttributeValueTrue(newValue)) {
					this.Select();
				}
				break;
			case "allow-close":
				if (this.IsAttributeValueTrue(newValue)) {
					this._allowClose = true;
				}

				if (this.IsAttributeValueTrue(newValue)) {
					this.#AddCloseButton();
				} else {
					this.querySelector(".tab__close-button")?.remove();
				}
				break;
			case "label":
				const span = this.querySelector(":scope > .btn--base > span");

				if (span) {
					span.textContent = newValue;
				}
				break;
		}
	}
}
